"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const one_1 = require("remax/one");
const classnames_1 = __importDefault(require("classnames"));
const one_2 = require("../one");
const dropdown_1 = __importDefault(require("../dropdown"));
const popup_1 = __importDefault(require("../popup"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('filter-item');
const Item = (props, ref) => {
    var _a;
    const { title, onTap, children, onShowMask, value, options = [], onChange, activeColor, disabled, } = props;
    const [open, setOpen] = react_1.useState(false);
    // const [height, setHeight] = useState("0");
    react_1.useImperativeHandle(ref, () => ({
        toggle() {
            setOpen(state => {
                if (state) {
                    setTimeout(() => {
                        onShowMask === null || onShowMask === void 0 ? void 0 : onShowMask(false);
                    });
                }
                else {
                    setTimeout(() => {
                        onShowMask === null || onShowMask === void 0 ? void 0 : onShowMask(true);
                    });
                }
                return !state;
            });
        },
        open() {
            setOpen(true);
        },
        close() {
            setOpen(false);
        },
    }), []);
    const handleTap = () => {
        if (disabled) {
            return;
        }
        setOpen(state => !state);
        onTap === null || onTap === void 0 ? void 0 : onTap(!open);
    };
    const handleChange = (e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
        setOpen(false);
        onShowMask === null || onShowMask === void 0 ? void 0 : onShowMask(false);
    };
    // React.useEffect(() => {
    //   wx.createSelectorQuery()
    //   .select(`#anna-filter-item-${id}`)
    //   .boundingClientRect((rect: any) => {
    //     setHeight(`${rect.height * 2}px`);
    //   })
    //   .exec()
    // }, [])
    return (react_1.default.createElement(one_1.View, { className: prefixCls },
        react_1.default.createElement(one_1.View, { style: { backgroundColor: '#FDFFFD' } },
            react_1.default.createElement(one_1.View, { className: classnames_1.default({
                    [`${prefixCls}-label`]: true,
                    [`${prefixCls}-label-disabled`]: disabled,
                }), onTap: handleTap },
                react_1.default.createElement(one_1.Text, { className: `${prefixCls}-label-text` }, ((_a = options === null || options === void 0 ? void 0 : options.find(option => option.key === value)) === null || _a === void 0 ? void 0 : _a.value) || title),
                open ? (react_1.default.createElement(one_1.Text, { className: `${prefixCls}-label-chevronUp` })) : (react_1.default.createElement(one_1.Text, { className: `${prefixCls}-label-chevronDown` })))),
        react_1.default.createElement(popup_1.default, { position: "bottom", square: true, curve: "ease", mask: false, open: open, style: {
                position: 'absolute',
                zIndex: -1,
                transform: open ? 'translate3d(0, 100%, 0)' : 'translate3d(0, 0, 0)',
            } },
            react_1.default.createElement(one_2.ScrollView, { scrollY: true, className: classnames_1.default({
                    [`${prefixCls}-value`]: true,
                }) }, children ? (children) : (react_1.default.createElement(dropdown_1.default, { value: value, options: options, onChange: handleChange, activeColor: activeColor }))))));
};
exports.default = react_1.default.forwardRef(Item);
